import { Component } from "react"


/* Every icon of the panel, drawn by hand in one place. They are all stroked lines on a 24 by 24
   grid and take the colour of the text around them, so one icon fits any background */
const PATHS = {

    dashboard: (
        <>
            <rect x="3.2" y="3.2" width="7.6" height="7.6" rx="2.2" />
            <rect x="13.2" y="3.2" width="7.6" height="7.6" rx="2.2" />
            <rect x="3.2" y="13.2" width="7.6" height="7.6" rx="2.2" />
            <rect x="13.2" y="13.2" width="7.6" height="7.6" rx="2.2" />
        </>
    ),

    booking: (
        <>
            <rect x="3.2" y="5" width="17.6" height="16" rx="3" />
            <path d="M3.2 10h17.6M8 3v4M16 3v4" />
            <path d="M9 15.4l2 2 4-4" />
        </>
    ),

    queue: (
        <>
            <path d="M4 9.2V6.6A1.6 1.6 0 0 1 5.6 5h12.8A1.6 1.6 0 0 1 20 6.6v2.6a2.8 2.8 0 0 0 0 5.6v2.6a1.6 1.6 0 0 1-1.6 1.6H5.6A1.6 1.6 0 0 1 4 17.4v-2.6a2.8 2.8 0 0 0 0-5.6Z" />
            <path d="M14.2 9.4v1.6M14.2 13v1.6" />
        </>
    ),

    organization: (
        <>
            <path d="M4.4 9.6V19a1.1 1.1 0 0 0 1.1 1.1h13a1.1 1.1 0 0 0 1.1-1.1V9.6" />
            <path d="M2.9 9.6h18.2l-1.36-4.05a1.6 1.6 0 0 0-1.52-1.1H5.78a1.6 1.6 0 0 0-1.52 1.1L2.9 9.6Z" />
            <path d="M9.9 20.1v-3.9a2.1 2.1 0 0 1 4.2 0v3.9" />
        </>
    ),

    category: (
        <>
            <path d="M4 6.6A2.6 2.6 0 0 1 6.6 4h3.3c.55 0 1.08.22 1.47.61l7.62 7.62a2.1 2.1 0 0 1 0 2.97l-3.84 3.84a2.1 2.1 0 0 1-2.97 0L4.61 11.4A2.1 2.1 0 0 1 4 9.93V6.6Z" />
            <path d="M8.6 8.6h.01" />
        </>
    ),

    user: (
        <>
            <circle cx="12" cy="8" r="3.7" />
            <path d="M4.6 20.2a7.4 7.4 0 0 1 14.8 0" />
        </>
    ),

    review: (
        <path d="M12 3.7l2.62 5.3 5.85.85-4.23 4.13 1 5.82L12 17.05l-5.24 2.75 1-5.82L3.53 9.85l5.85-.85L12 3.7Z" />
    ),

    support: (
        <>
            <path d="M20.8 11.6a8.4 8.4 0 0 1-12.15 7.5L3.4 20.6l1.5-5.15A8.4 8.4 0 1 1 20.8 11.6Z" />
            <path d="M12 8.2v3.6M12 14.9v.2" />
        </>
    ),

    service: (
        <>
            <circle cx="6.2" cy="6.2" r="2.5" />
            <circle cx="6.2" cy="17.8" r="2.5" />
            <path d="M20 4L8.7 16.1M8.7 7.9L20 20" />
        </>
    ),

    notification: (
        <>
            <path d="M18 9.2a6 6 0 1 0-12 0c0 4.9-2 6.4-2 6.4h16s-2-1.5-2-6.4Z" />
            <path d="M10.3 19.2a2 2 0 0 0 3.4 0" />
        </>
    ),

    master: (
        <>
            <circle cx="10" cy="8" r="3.8" />
            <path d="M3.4 20.2a6.6 6.6 0 0 1 13.2 0" />
            <path d="M18.6 8.4l.95 1.9 2.05.3-1.5 1.45.36 2.05-1.86-.98-1.86.98.36-2.05-1.5-1.45 2.05-.3.95-1.9Z" />
        </>
    ),

    wallet: (
        <>
            <path d="M18.6 7.6V5.8a1.8 1.8 0 0 0-1.8-1.8H5.4a2.2 2.2 0 0 0 0 4.4h13.8a1.6 1.6 0 0 1 1.6 1.6v8.8a1.6 1.6 0 0 1-1.6 1.6H5.4a2.2 2.2 0 0 1-2.2-2.2V6.2" />
            <path d="M20.8 12.2h-3.6a1.8 1.8 0 0 0 0 3.6h3.6" />
        </>
    ),

    gift: (
        <>
            <rect x="3.6" y="8.2" width="16.8" height="4" rx="1.2" />
            <path d="M5 12.2v7a1.6 1.6 0 0 0 1.6 1.6h10.8a1.6 1.6 0 0 0 1.6-1.6v-7M12 8.2v12.6" />
            <path d="M12 8.2S10.6 3.6 8 3.6a2.3 2.3 0 0 0 0 4.6M12 8.2s1.4-4.6 4-4.6a2.3 2.3 0 0 1 0 4.6" />
        </>
    ),

    ticket: (
        <>
            <path d="M3.6 8.4V6.6a1.8 1.8 0 0 1 1.8-1.8h13.2a1.8 1.8 0 0 1 1.8 1.8v1.8a3.6 3.6 0 0 0 0 7.2v1.8a1.8 1.8 0 0 1-1.8 1.8H5.4a1.8 1.8 0 0 1-1.8-1.8v-1.8a3.6 3.6 0 0 0 0-7.2Z" />
            <path d="M14.4 4.8v2.4M14.4 10.8v2.4M14.4 16.8v2.4" />
        </>
    ),

    shield: (
        <>
            <path d="M12 3.2l7.2 2.8v5.4c0 4.5-3 8.1-7.2 9.4-4.2-1.3-7.2-4.9-7.2-9.4V6l7.2-2.8Z" />
            <path d="M9 12l2.1 2.1L15.2 10" />
        </>
    ),

    otp: (
        <>
            <rect x="6.6" y="2.8" width="10.8" height="18.4" rx="2.8" />
            <path d="M10.4 18.2h3.2" />
            <path d="M9.6 8.4h4.8M9.6 12h2.6" />
        </>
    ),

    admin: (
        <>
            <path d="M12 3.2l7 2.9v5.4c0 4.2-2.85 7.9-7 9.3-4.15-1.4-7-5.1-7-9.3V6.1l7-2.9Z" />
            <path d="M9.2 12.1l2.1 2.1 3.9-4" />
        </>
    ),

    settings: (
        <>
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" />
        </>
    ),

    more: (
        <>
            <circle cx="5.5" cy="12" r="1.4" fill="currentColor" stroke="none" />
            <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
            <circle cx="18.5" cy="12" r="1.4" fill="currentColor" stroke="none" />
        </>
    ),

    logout: (
        <>
            <path d="M14.5 8V6.6A2.6 2.6 0 0 0 11.9 4H6.6A2.6 2.6 0 0 0 4 6.6v10.8A2.6 2.6 0 0 0 6.6 20h5.3a2.6 2.6 0 0 0 2.6-2.6V16" />
            <path d="M20 12H9.5M20 12l-3.1-3.1M20 12l-3.1 3.1" />
        </>
    ),

    profile: (
        <>
            <circle cx="12" cy="12" r="8.6" />
            <circle cx="12" cy="10" r="2.8" />
            <path d="M6.7 18.4a6 6 0 0 1 10.6 0" />
        </>
    ),

    password: (
        <>
            <rect x="4.6" y="10.2" width="14.8" height="10.4" rx="2.8" />
            <path d="M8.2 10.2V7.6a3.8 3.8 0 0 1 7.6 0v2.6" />
            <path d="M12 14.6v1.8" />
        </>
    ),

    /* The sidebar folds — a panel with its column and an arrow into it */
    sidebarClose: (
        <>
            <rect x="3.2" y="4.2" width="17.6" height="15.6" rx="3" />
            <path d="M9.2 4.2v15.6M15.8 9.6L13.4 12l2.4 2.4" />
        </>
    ),

    /* The sidebar unfolds — the arrow points out of the column */
    sidebarOpen: (
        <>
            <rect x="3.2" y="4.2" width="17.6" height="15.6" rx="3" />
            <path d="M9.2 4.2v15.6M13.4 9.6l2.4 2.4-2.4 2.4" />
        </>
    ),

    collapse: (
        <path d="M13.4 6.8L8.6 12l4.8 5.2M18.4 6.8L13.6 12l4.8 5.2" />
    ),

    left: (
        <path d="M14.4 6.4L8.8 12l5.6 5.6" />
    ),

    right: (
        <path d="M9.6 6.4L15.2 12l-5.6 5.6" />
    ),

    up: (
        <path d="M6.4 14.4L12 8.8l5.6 5.6" />
    ),

    down: (
        <path d="M6.4 9.6L12 15.2l5.6-5.6" />
    ),

    grip: (
        <path d="M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01" />
    ),

    layers: (
        <>
            <path d="M12 3.6l8.4 4.2-8.4 4.2-8.4-4.2L12 3.6Z" />
            <path d="M3.6 12l8.4 4.2 8.4-4.2M3.6 16.2l8.4 4.2 8.4-4.2" />
        </>
    ),

    sparkle: (
        <>
            <path d="M12 3.6l1.7 4.9 4.9 1.7-4.9 1.7L12 16.8l-1.7-4.9-4.9-1.7 4.9-1.7L12 3.6Z" />
            <path d="M18.6 15.6l.7 1.9 1.9.7-1.9.7-.7 1.9-.7-1.9-1.9-.7 1.9-.7.7-1.9Z" />
        </>
    ),

    sort: (
        <path d="M7.2 4.8v14.4M7.2 19.2l-3-3M7.2 19.2l3-3M16.8 19.2V4.8M16.8 4.8l-3 3M16.8 4.8l3 3" />
    ),

    wifiOff: (
        <>
            <path d="M3.6 3.6l16.8 16.8" />
            <path d="M8.4 12.9a5.4 5.4 0 0 1 3.6-1.3M5.1 9.6A10 10 0 0 1 8 7.9M2.4 6.8a14 14 0 0 1 2.3-1.4M15.9 11.9a5.5 5.5 0 0 1 .9.7M13.3 7.1A10 10 0 0 1 18.9 9.6M10.2 3.9a14 14 0 0 1 11.4 2.9" />
            <path d="M12 18.4h.01" />
        </>
    ),

    check: (
        <path d="M5 12.6l4.4 4.4L19 7.4" />
    ),

    alert: (
        <>
            <circle cx="12" cy="12" r="8.8" />
            <path d="M12 7.6v5M12 15.9v.3" />
        </>
    ),

    question: (
        <>
            <circle cx="12" cy="12" r="8.8" />
            <path d="M9.6 9.4a2.5 2.5 0 0 1 4.85.85c0 1.7-2.45 2.05-2.45 3.75M12 16.6v.2" />
        </>
    ),

    edit: (
        <>
            <path d="M4.6 19.4h3.3l9.5-9.5a2.33 2.33 0 0 0-3.3-3.3l-9.5 9.5v3.3Z" />
            <path d="M13.4 7.6l3 3" />
        </>
    ),

    qr: (
        <>
            <rect x="3.6" y="3.6" width="6.6" height="6.6" rx="1.6" />
            <rect x="13.8" y="3.6" width="6.6" height="6.6" rx="1.6" />
            <rect x="3.6" y="13.8" width="6.6" height="6.6" rx="1.6" />
            <path d="M13.8 13.8h3.2v3.2M20.4 20.4h-3.2M20.4 13.8v.02M13.8 20.4v.02" />
        </>
    ),

    power: (
        <>
            <path d="M12 4.4v7" />
            <path d="M7.5 7a6.8 6.8 0 1 0 9 0" />
        </>
    ),

    crown: (
        <>
            <path d="M4.2 18.4h15.6" />
            <path d="M4.6 15.6L3.2 6.6l4.8 3.4L12 4.4l4 5.6 4.8-3.4-1.4 9H4.6Z" />
        </>
    ),

    refresh: (
        <>
            <path d="M20.2 12a8.2 8.2 0 1 1-2.4-5.8" />
            <path d="M20.4 4.2v4.4h-4.4" />
        </>
    ),

    image: (
        <>
            <rect x="3.6" y="4.6" width="16.8" height="14.8" rx="2.6" />
            <circle cx="9" cy="9.8" r="1.6" />
            <path d="M4.2 17l4.6-4.6a1.8 1.8 0 0 1 2.5 0l5.1 5.1M14.6 14.6l1.5-1.5a1.8 1.8 0 0 1 2.5 0l1.6 1.6" />
        </>
    ),

    archive: (
        <>
            <rect x="3.4" y="4.6" width="17.2" height="4.2" rx="1.4" />
            <path d="M5.2 8.8v9a2 2 0 0 0 2 2h9.6a2 2 0 0 0 2-2v-9" />
            <path d="M10 12.6h4" />
        </>
    ),

    trash: (
        <>
            <path d="M4.5 6.8h15" />
            <path d="M9.2 6.8V5.4A1.6 1.6 0 0 1 10.8 3.8h2.4a1.6 1.6 0 0 1 1.6 1.6v1.4" />
            <path d="M6.6 6.8l.9 12.1a2 2 0 0 0 2 1.9h5a2 2 0 0 0 2-1.9l.9-12.1" />
            <path d="M10.4 10.6v6M13.6 10.6v6" />
        </>
    ),

    close: (
        <path d="M6.6 6.6l10.8 10.8M17.4 6.6L6.6 17.4" />
    ),

    search: (
        <>
            <circle cx="10.8" cy="10.8" r="6.6" />
            <path d="M15.6 15.6L20.4 20.4" />
        </>
    ),

    plus: (
        <path d="M12 5.4v13.2M5.4 12h13.2" />
    ),

    calendar: (
        <>
            <rect x="3.2" y="5" width="17.6" height="16" rx="3" />
            <path d="M3.2 10h17.6M8 3v4M16 3v4" />
        </>
    ),

    filter: (
        <>
            <path d="M3.6 6.6h16.8M6.6 12h10.8M10.2 17.4h3.6" />
        </>
    ),

    eye: (
        <>
            <path d="M2.4 12S6 5.4 12 5.4 21.6 12 21.6 12 18 18.6 12 18.6 2.4 12 2.4 12Z" />
            <circle cx="12" cy="12" r="3.1" />
        </>
    ),

    card: (
        <>
            <rect x="2.8" y="5.2" width="18.4" height="13.6" rx="3" />
            <path d="M2.8 9.9h18.4" />
            <path d="M6.6 14.8h3.4" />
        </>
    ),

    trend: (
        <>
            <path d="M3.6 16.8l5.4-5.4 3.6 3.6 7.8-7.8" />
            <path d="M15.6 7.2h4.8v4.8" />
        </>
    ),

    clock: (
        <>
            <circle cx="12" cy="12" r="8.6" />
            <path d="M12 7.2V12l3.2 1.9" />
        </>
    ),

    lead: (
        <>
            <circle cx="11" cy="13" r="7.8" />
            <circle cx="11" cy="13" r="3.6" />
            <path d="M11 13l8.4-8.4M16.4 4.2l3 .4.4 3" />
        </>
    ),

    phone: (
        <path d="M20.6 16.5v2.6a1.7 1.7 0 0 1-1.86 1.7 16.9 16.9 0 0 1-7.36-2.62 16.6 16.6 0 0 1-5.1-5.1A16.9 16.9 0 0 1 3.66 5.7 1.7 1.7 0 0 1 5.35 3.85h2.6a1.7 1.7 0 0 1 1.7 1.46c.11.83.31 1.64.6 2.42a1.7 1.7 0 0 1-.38 1.8l-1.1 1.1a13.6 13.6 0 0 0 5.1 5.1l1.1-1.1a1.7 1.7 0 0 1 1.8-.38c.78.29 1.59.49 2.42.6a1.7 1.7 0 0 1 1.46 1.72Z" />
    ),

    eyeOff: (
        <>
            <path d="M9.9 5.7A8.9 8.9 0 0 1 12 5.4c6 0 9.6 6.6 9.6 6.6a17 17 0 0 1-2.8 3.7" />
            <path d="M6.6 7.1A16.7 16.7 0 0 0 2.4 12S6 18.6 12 18.6c1.6 0 3-.45 4.2-1.1" />
            <path d="M9.9 9.95a3.1 3.1 0 0 0 4.25 4.25" />
            <path d="M4.2 4.2l15.6 15.6" />
        </>
    )
}


/* Component Icon — one drawing out of the set above */
class Icon extends Component {

    render = () => {

        /* Fields */
        const { name, size = 22, width = 1.7 } = this.props

        /* An unknown name draws nothing instead of breaking the page */
        if (!PATHS[name]) {
            return null
        }

        return (
            <svg
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={width}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {PATHS[name]}
            </svg>
        )
    }
}

export default Icon
